export default function auth({ next, to, router }) {
  const token = localStorage.getItem("sakn_w_safar_admin_dashboard_user_token");

  if (!token) {
    // Already on login — avoid redirect loop
    if (to.path === "/" || to.name === "LoginForm") {
      return next();
    }
    return next({ path: "/", replace: true });
  }

  return next();
}
